import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp } from 'lucide-react';
export function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-1606" data-mp="25isa14ta6hul">
      {visible && <motion.button initial={{
      opacity: 0,
      scale: 0.8,
      y: 10
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.8,
      y: 10
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} onClick={scrollToTop} className="fixed bottom-6 right-6 z-40 w-9 h-9 bg-stone-900/30 dark:bg-white/10 backdrop-blur-md border border-stone-900/10 dark:border-white/15 text-white/90 rounded-full flex items-center justify-center shadow-md opacity-70 hover:opacity-100 hover:bg-stone-900/50 dark:hover:bg-white/20 transition-all" aria-label="Scroll to top" data-id="element-1607" data-mp="25hgwida19vqa">
          <ArrowUp className="w-4 h-4" data-id="element-1608" data-mp="ktgmwaavwuih" />
        </motion.button>}
    </AnimatePresence>;
}